import ReasonSelector from '@atoms/ReasonSelector';
import ReasonsModal from '@molecules/ReasonsModal';
import { getStore } from '@store/storeUtils';
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import logReasonSelected from './analyticsEditReasons';

interface EditReasonsProps {
  iconUrl: string;
  transReason: string;
  position?: 'DECREASE' | 'INCREASE';
  disabled?: boolean;
  transReasonId: string;
}

interface SelectedTxnReason {
  transReason: string;
  iconUrl: string;
}

interface WithdrawalReason {
  id: number;
  reason: string;
  imageUrl: string;
}

interface Account {
  id: string;
  [key: string]: any;
}

export function shouldShowReasonsModal(
  showReasonSelector: boolean,
  setShowReasonSelector: (show: boolean) => void,
  reasonData: WithdrawalReason | null,
  setWithdrawalReason: (reason: WithdrawalReason) => void,
  account: Account,
  position: 'DECREASE' | 'INCREASE',
): React.ReactElement | null {
  if (showReasonSelector) {
    return (
      <ReasonsModal
        showReasonSelector={showReasonSelector}
        setShowReasonSelector={setShowReasonSelector}
        reasonData={reasonData}
        setReason={setWithdrawalReason}
        account={account}
        position={position}
        isEditReasons
      />
    );
  }
  return null;
}

const EditReasons: React.FC<EditReasonsProps> = ({
  iconUrl,
  transReason,
  position = 'DECREASE',
  disabled = true,
  transReasonId,
}) => {
  const [showReasonSelector, setShowReasonSelector] = useState<boolean>(false);
  const { selectedTxnAccount, withdrawalReason, setWithdrawalReason } = getStore();
  const [selectedTxnReason, setSelectedTxnReason] = useState<SelectedTxnReason>({
    transReason: transReason || '',
    iconUrl: iconUrl || '',
  });

  useEffect(() => {
    if (withdrawalReason) {
      setSelectedTxnReason({
        transReason: withdrawalReason.reason || '',
        iconUrl: withdrawalReason.imageUrl || '',
      });
    } else {
      setWithdrawalReason({
        id: parseInt(transReasonId, 10),
        reason: transReason || '',
        imageUrl: iconUrl || '',
      });
    }
  }, [withdrawalReason]);

  const onReasonSelectorHandler = (): void => {
    setShowReasonSelector(true);
    logReasonSelected();
  };

  return (
    <View>
      <ReasonSelector
        disabled={disabled}
        onPress={onReasonSelectorHandler}
        iconUrl={selectedTxnReason.iconUrl}
        selectedReason={selectedTxnReason.transReason}
      />
      {shouldShowReasonsModal(
        showReasonSelector,
        setShowReasonSelector,
        withdrawalReason,
        setWithdrawalReason,
        selectedTxnAccount as Account,
        position,
      )}
    </View>
  );
};

export default React.memo(EditReasons);
